import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useMe } from '../../../shared/hooks/useMe';
import { canTrainHelios } from '../../../shared/permissions/capabilities';
import ReviewAnswers from './ReviewAnswers';

/**
 * /questionnaire/review is part of Train Helios (quest.train_helios); same as the gated card + RAG upload.
 */
const TrainHeliosReviewGate: React.FC = () => {
  const { me, loading } = useMe();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!canTrainHelios(me)) {
    return <Navigate to="/forbidden" replace />;
  }

  return <ReviewAnswers />;
};

export default TrainHeliosReviewGate;
